import {ObvioEvent} from 'Event'
import {Client} from 'lib/ui/api-client'
import {api} from 'lib/url'
import {useQuery} from 'react-query'

export type ObieAttendeeLink = {
  id: number
  label: string
  slug: string
  obie_journey_id: string
  obie_milestone_id: string | null
  obie_step_id: string | null
}

export type ObieAttendeeLinkData = Omit<ObieAttendeeLink, 'id'>

export type ObieAttendeeLinkError = {
  message: string
  errors?: {
    slug?: string[]
  }
}

export function useObieAttendeeLinks(params: {
  client: Client
  event: ObvioEvent
}) {
  const {client, event} = params

  return useQuery<ObieAttendeeLink[], {message: string}>({
    queryKey: ['events', event.id, 'integrations', 'obie', 'attendee_links'],
    queryFn: () =>
      client.get<ObieAttendeeLink[]>(
        api(`/events/${event.id}/integrations/obie/attendee_links`),
      ),
  })
}
